<template>
    <div class="jumping-dots-loader">
        <span :style="{ backgroundColor: fill }"></span>
        <span :style="{ backgroundColor: fill }"></span>
        <span :style="{ backgroundColor: fill }"></span>
    </div>
</template>

<script>
export default {
    props: {
        fill: {
            type: String,
            default: "#2F3941"
        }
    }
};
</script>

<style lang="scss" scoped>
.jumping-dots-loader {
    position: relative;
    text-align: center;
}

.jumping-dots-loader span {

    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 100%;
    margin: 35px 5px;
}

.jumping-dots-loader span:nth-child(1) {
    animation: bounce 1s ease-in-out infinite;
}

.jumping-dots-loader span:nth-child(2) {
    animation: bounce 1s ease-in-out 0.33s infinite;
}

.jumping-dots-loader span:nth-child(3) {
    animation: bounce 1s ease-in-out 0.66s infinite;
}

@keyframes bounce {

    0%,
    75%,
    100% {
        -webkit-transform: translateY(0);
        -ms-transform: translateY(0);
        -o-transform: translateY(0);
        transform: translateY(0);
    }

    25% {
        -webkit-transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        -o-transform: translateY(-10px);
        transform: translateY(-10px);
    }
}
</style>